const getTooltipSideOffset = (size, isButton)=>{
    const offsets = isButton ? {
        sm: 12,
        lg: 21,
        xl: 18
    } : {
        sm: 12,
        md: 21,
        lg: 18
    };
    if (!size) return offsets.md || offsets.lg;
    return offsets[size];
};
export { getTooltipSideOffset };
